import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { api } from './api';
import { Login } from './Login.jsx';
import App from './App.jsx';
import './styles.css';

type Node = { id: string; [k: string]: any };
type Edge = { id: string; [k: string]: any };
type User = { id: string; email: string; name: string | null };

function Splash({ label }: { label: string }) {
  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0c', color: '#f0a800',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'ui-monospace,Menlo,monospace', fontSize: 13, letterSpacing: '0.25em',
    }}>
      {label}
    </div>
  );
}

function ErrorScreen({ error }: { error: string }) {
  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0c', color: '#f0a800',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 12, padding: 20,
      fontFamily: '-apple-system,BlinkMacSystemFont,sans-serif',
    }}>
      <div style={{ fontSize: 14, opacity: 0.7 }}>Fluxo · erro</div>
      <div style={{ fontSize: 12, fontFamily: 'ui-monospace,monospace', maxWidth: 600, textAlign: 'center' }}>
        {error}
      </div>
      <button
        onClick={() => location.reload()}
        style={{ padding: '8px 16px', background: '#f0a800', color: '#0a0a0c', border: 0, borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
      >
        tentar de novo
      </button>
    </div>
  );
}

function AppBooted() {
  const [state, setState] = useState<'checking' | 'login' | 'hydrating' | 'ready' | 'error'>('checking');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        await api.me();
        await hydrate();
      } catch {
        setState('login');
      }
    })();
  }, []);

  async function hydrate() {
    setState('hydrating');
    try {
      const { plan, nodes, edges } = await api.getDefaultPlan();
      const wsHandle: any = api.connectPlan(plan.id, {
        onSnapshot: () => {},
        onNodeUpsert: (node: Node) => (window as any).__bootstrap?.ws?.onNodeUpsert?.(node),
        onNodeDelete: (id: string) => (window as any).__bootstrap?.ws?.onNodeDelete?.(id),
        onEdgeUpsert: (edge: Edge) => (window as any).__bootstrap?.ws?.onEdgeUpsert?.(edge),
        onEdgeDelete: (id: string) => (window as any).__bootstrap?.ws?.onEdgeDelete?.(id),
      });
      (window as any).__bootstrap = { plan, nodes, edges, ws: wsHandle };
      setState('ready');
    } catch (e: any) {
      setErr(e?.message ?? String(e));
      setState('error');
    }
  }

  if (state === 'checking') return <Splash label="verificando sessão…" />;
  if (state === 'login') return <Login onSuccess={(_u: User) => hydrate()} />;
  if (state === 'hydrating') return <Splash label="carregando fluxo…" />;
  if (state === 'error') return <ErrorScreen error={err ?? 'erro'} />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<React.StrictMode><AppBooted /></React.StrictMode>);
